import { Component, OnDestroy, OnInit, Input, HostListener, ChangeDetectorRef, ChangeDetectionStrategy } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { BrokerService } from 'src/app/core/services/broker.service';
import { MetatagsService } from 'src/app/core/services/metatags.service';
import { OfferService } from 'src/app/core/services/offer.service';
import { SesionService } from 'src/app/core/services/sesion.service';
import { environment } from 'src/environments/environment';
import { Title, Meta } from '@angular/platform-browser';
import { ModalService } from 'src/app/core/services/modal.service';
import { CookieService } from 'ngx-cookie-service';
import { LoadService } from 'src/app/core/services/load.service';
import { UtilitiesService } from 'src/app/core/services/utilities.service';
import { DataLayersService } from 'src/app/core/services/data-layers.service';
import { OfferViewModel } from 'src/app/core/models/offer-view.model';

declare const $: any;

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class HomeComponent implements OnInit, OnDestroy {
  public testimonials: any[] = [];
  @Input() childMessage!: string;
  arrayCategory: any = [];
  btnActive: any = [];
  flagFilter: boolean = false;
  loginUrl: any;
  bannerHome = false;
  scroll: number = window.pageYOffset;
  public isMobile = false;
  public errorOfertas: boolean = false;
  public noOffers: boolean = true;
  public numOffers: number = 0;
  public endCallServiceOffers = false;
  public flagEnd: boolean = false;
  public topOffers: OfferViewModel[] = [];
  public listCategories = [
    { id: '1', name: 'Credito libre inversion', backImg: 'assets/images/home/cards/categoria_credito_libre.png', title: '¿GANAS DE <span>VACACIONES?</span>', icon: 'assets/images/home/icons-cards/icono_creditos_libres.svg', comment: 'Conoce las ofertas de Crédito de <b>Libre Inversión</b>.', url: '/creditos/libre-inversion' },
    { id: '2', name: 'Cuentas ahorros', backImg: 'assets/images/home/cards/categoria_cuenta_ahorro.png', title: '<span>ADMINISTRA</span>&nbsp; TU DINERO', icon: 'assets/images/home/icons-cards/icono_creditos_libres.svg', comment: 'Conoce las ofertas de <b>Cuentas de Ahorro</b>.', url: '/ahorros-inversion' },
    { id: '3', name: 'Credito hipotecario', backImg: 'assets/images/home/cards/categoria_credito_hipotecario.png', title: '¿QUIERES <span>CASA PROPIA?</span>', icon: 'assets/images/home/icons-cards/icono_hipotecario.svg', comment: 'Conoce las ofertas de Créditos <b>Hipotecarios</b>.', url: '/creditos/vivienda' },
    { id: '4', name: 'Tarjetas credito', backImg: 'assets/images/home/cards/categoria_tarejta_credito.png', title: '¿BUSCANDO <span>TARJETAS?</span>', icon: 'assets/images/home/icons-cards/icono_tarjeta_credito.svg', comment: 'Conoce las ofertas de <b>Tarjetas de Crédito</b>.', url: '/tarjetas-credito' }
  ]

  public categorieMain: any = this.listCategories[0];
  public categorieAfter: any = this.listCategories[1];
  public categorieBefore: any = this.listCategories[this.listCategories.length - 1];

  constructor(
    public sesion: SesionService,
    private activateRoute: ActivatedRoute,
    public router: Router,
    public offer: OfferService,
    public broker: BrokerService,
    public metaServ: MetatagsService,
    private _title: Title,
    private _metaService: Meta,
    private cookieService: CookieService,
    public load: LoadService,
    public utilities: UtilitiesService,
    public modal: ModalService,
    private dataLayerService: DataLayersService,
    private cdr: ChangeDetectorRef,
    private http: HttpClient) {

    this.loginUrl = environment.urlLogin;
    this.activateRoute.queryParams.subscribe((params): any => {
      if (params['homeType']) {
        localStorage.setItem('homeType', params['homeType']);
      }
    });

    this.isMobile = window.innerWidth <= 768;

    router.events.subscribe((val) => {
      if (val instanceof NavigationEnd) {
        if (val.url == "/" || val.url.toLocaleLowerCase().includes('utm')) {
          this.utilities.getUtmParams();
        }
      }
    });
  }

  // Mostrar título para móvil y Ocultar título para escritorio
  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.isMobile = event.target.innerWidth <= 768;
  }

  ngOnInit() {
    if (this.activateRoute.snapshot.paramMap.get('category') != null) {
      this.flagFilter = true;
    }

    this.setCategory();
    this.loadTestimonials();

    this._title.setTitle('Buscacrédito | Las mejores ofertas de créditos, inversión y más');
    this._metaService.updateTag({
      name: 'description', content: 'Busca y compara múltiples ofertas de créditos y muchos productos financieros más! Desembolsos completamente online y preaprobaciones gratis.'
    });
    this.metaServ.createCanonicaURL('https://buscacredito.midatacredito.com');

    this.getOffersLogOut();

    this.dataLayerService.dl_eventoGA4_general('carga_home');
  }

  ngAfterViewInit() {
    $(".title-category").children('span').css({ 'background-color': '#ffffff', 'color': '#000000', });
  }

  ngAfterContentInit() {
    this.checkBannerHome();
  }
  /**
   * Esta funcion se encarga de cerrar la sesion mediante el llamado del servicio /authn/signOff y limpiar la informacionmpara acceder al sitio
   */
  closeSession() {
    const body = {
      clientId: environment.clientId,
      idSession: this.sesion.sesionCookie,
      country: environment.country
    };
    this.broker.cerrar_sesion(body).subscribe((response: any) => {
      this.borrarData();
    },
      (error) => {
        this.borrarData();
      });
  }

  /**
   * FUncion que elimina informacion de ingreso, cookies y al final redirecciona al inicio 
   */
  borrarData() {
    window.localStorage.clear();
    this.cookieService.delete('IDSESSIONMDC', this.sesion.sesionCookie, environment.domain);
    this.sesion.sesionCookie = null;
    this.router.navigate(['/']);
  }

  /**
   * Esta funcion llama al archivo Ubicado en el cloud front de las categorias y carga la informacion
   */
  setCategory() {
    if (this.arrayCategory.length === 0) {
      this.broker.getCategories().subscribe((response: any) => {
        this.arrayCategory = Array.isArray(response) ? response : response?.categories ?? [];
        this.arrayCategory = this.arrayCategory.filter((element: any) => element.state == 1);
      });
    }
  }

  private loadTestimonials() {
    this.http
      .get<{ testimonials: any[] }>('assets/data/testimonials.json')
      .subscribe((response) => {
        this.testimonials = response.testimonials;
      });
  }


  /**
   * Esta función envia un evento data layer por la categoria seleccionada en los iconos.
   * Envia el data layer "clic_icons_credit"
   * @param texto_boton texto del botón accionado 
   */
  envio_datalayer_iconos(texto_boton: string) {
    this.dataLayerService.dl_eventoGA4_menu('clic_icons_credit', texto_boton);
  }

  /**
   * Esta funcion valida si el banner no esxite para cargarlo nuevamente
   */
  checkBannerHome() {
    let tamano = [[728, 90], [300, 50]];
    this.utilities.addAdsById(environment.slotsBanners.home, 'div-gpt-ad-1683582277702-0', tamano);
  }

  /**
 * Funcion que llama al servicio de freeOffers y homeOffers para hacer una sola lista de ofertas 
 * e inicilializa los filtros
 */
  getOffersLogOut() {
    this.load.openMicro('');
    this.errorOfertas = false;
    this.offer.offersList = [];
    this.offer.offersFil = [];
    this.endCallServiceOffers = false;
    this.noOffers = true;
    const offersDebug = environment.gtmPruebas === true || environment.envName !== 'master';
    this.broker.getOffers(2).subscribe({
      next: (result: any) => {
        try {
          if (offersDebug) {
            const rawCompanies = Array.isArray(result) ? result : (Array.isArray(result?.data) ? result.data : []);
            let rawOfferCount = 0;
            let rawOffersWithFilters = 0;
            let rawSampleWithFilters: any = null;
            rawCompanies.forEach((c: any) => {
              const offers = Array.isArray(c?.offers) ? c.offers : [];
              offers.forEach((o: any) => {
                rawOfferCount++;
                // filters viene a nivel de oferta (nueva estructura) o dentro de detail (legacy)
                const filters = Array.isArray(o?.filters) && o.filters.length > 0
                  ? o.filters
                  : (Array.isArray(o?.detail?.filters) ? o.detail.filters : null);
                if (Array.isArray(filters) && filters.length > 0) {
                  rawOffersWithFilters++;
                  if (!rawSampleWithFilters) {
                    rawSampleWithFilters = {
                      companyId: c?.company?.id,
                      offerId: o?.id,
                      productName: o?.card?.productName,
                      filtersIds: filters.map((f: any) => f?.id)
                    };
                  }
                }
              });
            });
            console.log('[Home] homeOffers raw filters', {
              isArray: Array.isArray(result),
              rawOfferCount,
              rawOffersWithFilters,
              sample: rawSampleWithFilters
            });
          }

          if (result.message == 'No home offers to show') {
            this.noOffers = true;
            this.load.closeMicro();
          }
          if (result.status == undefined) {
            const convertedHome = this.offer.convertOffer(result);
            if (offersDebug) {
              const convertedWithFilters = convertedHome.filter((o: any) => Array.isArray(o?.detail?.filters) && o.detail.filters.length > 0);
              const sampleConverted = convertedWithFilters?.[0];
              console.log('[Home] homeOffers converted filters', {
                convertedCount: convertedHome?.length ?? 0,
                convertedWithFilters: convertedWithFilters?.length ?? 0,
                sample: sampleConverted ? {
                  companyId: sampleConverted.company?.id,
                  offerId: sampleConverted.offerId,
                  productName: sampleConverted.card?.productName,
                  filtersIds: sampleConverted.detail?.filters?.map((f: any) => f?.id)
                } : null
              });
            }
            this.offer.offersList = this.offer.offersList.concat(convertedHome);
            this.broker.getOffersFree().subscribe((result2: any) => {
              // Callback asincrono: un throw aqui no lo captura el try/catch exterior,
              // por lo que se protege aparte para no dejar el micro-loader abierto para siempre.
              try {
                if (result2.status == undefined) {
                  const convertedFree = this.offer.convertOffer(result2, true);
                  if (offersDebug) {
                    const convertedWithFilters = convertedFree.filter((o: any) => Array.isArray(o?.detail?.filters) && o.detail.filters.length > 0);
                    const sampleConverted = convertedWithFilters?.[0];
                    console.log('[Home] freeOffers converted filters', {
                      convertedCount: convertedFree?.length ?? 0,
                      convertedWithFilters: convertedWithFilters?.length ?? 0,
                      sample: sampleConverted ? {
                        companyId: sampleConverted.company?.id,
                        offerId: sampleConverted.offerId,
                        productName: sampleConverted.card?.productName,
                        filtersIds: sampleConverted.detail?.filters?.map((f: any) => f?.id)
                      } : null
                    });
                  }
                  this.offer.offersList = this.offer.offersList.concat(convertedFree);
                }
                this.topOffers = this.offer.sortOffer(this.offer.offersList).slice(0, 3);
                if (this.topOffers.length > 0) {
                  this.noOffers = false;
                  this.dataLayerService.dl_eventoGA4_general('cargar_home_ofertas_destacadas');
                }
              } catch (error) {
                this.errorOfertas = true;
                this.noOffers = true;
              } finally {
                this.load.closeMicro();
                this.flagEnd = true;
                this.endCallServiceOffers = true;
                // Pinta las ofertas en el mismo ciclo en que se oculta el loader; sin esto queda
                // una pantalla en blanco hasta el proximo tick ambiental de change detection.
                this.cdr.detectChanges();
              }
            });
          }
        } catch (error) {
          this.endCallServiceOffers = true;
          this.errorOfertas = true;
          this.noOffers = true;
          this.load.closeMicro();
        }

      },
      error: () => {
        this.endCallServiceOffers = true;
        this.errorOfertas = true;
        this.noOffers = true;
        this.load.closeMicro();
      }
    });
  }

  moveCategorie(after: boolean) {
    let num = (after ? 1 : -1);
    let indexMain = (this.categorieMain.id - 1) + num;
    if (indexMain >= this.listCategories.length) {
      indexMain = 0;
    }
    if (indexMain < 0) {
      indexMain = this.listCategories.length - 1;
    }
    let indexAfter = (this.categorieAfter.id - 1) + num;
    if (indexAfter >= this.listCategories.length) {
      indexAfter = 0;
    }
    if (indexAfter < 0) {
      indexAfter = this.listCategories.length - 1;
    }
    let indexBefore = (this.categorieBefore.id - 1) + num;
    if (indexBefore >= this.listCategories.length) {
      indexBefore = 0;
    }
    if (indexBefore < 0) {
      indexBefore = this.listCategories.length - 1;
    }
    this.categorieMain = this.listCategories[indexMain];
    this.categorieAfter = this.listCategories[indexAfter];
    this.categorieBefore = this.listCategories[indexBefore];
  }

  addClass(event: Event, nameClass: string) {
    let htmlEle = event.target as HTMLElement;
    let children = (htmlEle.parentElement?.parentElement?.children) as any;
    if (children != undefined) {
      for (let child of children) {
        child.classList.remove(nameClass);
      }
    }
    htmlEle.parentElement?.classList.add(nameClass);
  }

  irCategorias(categoria: string = '',name:string = '') {
    this.dataLayerService.dl_eventoGA4_event_button('clic_home_ofertas', 'Ver Ofertas')
    if (this.sesion.isIdsession()) {
      if (categoria == '') {
        this.router.navigate(['/ofertas']);
      } else {
        this.router.navigate(['/ofertas' + categoria]);
        let namet = name.normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/[" "]/g,"_").toLowerCase();
        this.dataLayerService.dl_eventoGA4_menu('clic_categoria_menu', namet);
      }
    } else if (categoria == '') {
      this.router.navigate(['/categoria']);
    } else {
      this.router.navigate(['/categoria' + categoria]);
      let namet = name.normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/[" "]/g,"_").toLowerCase();
      this.dataLayerService.dl_eventoGA4_menu('clic_categoria_menu', namet);
    }
  
  }

  ngOnDestroy(): void {
    this.dataLayerService.clearViewedCardOffers();
  }

}
